export const durationToHours = (duration: number) => duration / 60;
export const hoursToDuration = (hours: number) => hours * 60;
export const durationToMinutes = (duration: number) => duration;
export const minutesToDuration = (minutes: number) => minutes;
